<template>
    <div class="progress" style="height: 13px;">
        <div class="custom-progress-bar" :style="{ width: currentProgress + '%', height: '8px' }"
            :class="getColor()"
            role="progressbar" :aria-valuenow="currentProgress" aria-valuemin="0" aria-valuemax="100">
            <div class="circle"></div> <!-- Círculo dentro da barra de progresso -->
        </div>
        <span class="progress-value" :style="{ left: currentProgress + '%', transform: 'translateX(-50%)' }">
            {{ currentProgress.toFixed(1) }}%
        </span>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        value: {
            type: Number,
            required: true
        },
        level: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            currentProgress: 0
        };
    },
    mounted() {
        this.animateProgress();
    },
    methods: {
        getColor(){

            if(this.level == 1){
                return 'progress-success';
            } else if(this.level == 2){
                return 'progress-warning'
            } else if(this.level == 3){
                return 'progress-danger'
            } else {
                return 'progress-info'
            }
        },
        animateProgress() {
            const interval = setInterval(() => {
                if (this.currentProgress >= this.value) {
                    clearInterval(interval);
                } else {
                    this.currentProgress += 0.5;
                }
            }, 20);
        }
    }
};
</script>

<style scoped>
.progress {
    overflow: visible;
    position: relative;
    display: flex;
    align-items: center;
}

.custom-progress-bar {
    position: relative;
    transition: width 0.3s ease;    
}

.progress-success {
    background-color: #3cd188 !important;
}

.progress-warning {
    background-color: #efae4e !important;
}

.progress-info {
    background-color: #0dc4f5 !important;
}

.progress-danger {
    background-color: #f7666e !important;
}

.circle {
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 50%;
    right: -2px;
    /* Ajusta a posição do círculo para dentro da área colorida */
    top: 50%;
    transform: translateY(-50%);
}

.progress-value {
    position: absolute;
    top: -25px;
    /* Fica acima da barra de progresso */
    font-weight: bold;
    color: white;
    background-color: #264c86;
    padding: 5px 10px;
    border-radius: 5px;
    transition: left 0.3s ease;
    /* Faz a transição do valor conforme a barra cresce */
    z-index: 2;
    /* Garante que o valor fique acima da barra de progresso */
}
</style>